module.exports = __webpack_public_path__ + "img/Gage.7792baac.jpg";